<template>
  <ReportsPage
    :forecast-subscription="forecastSubscription"
    :market-assessment-subscription="marketAssessmentSubscription"
    :prices-assessment-subscription="subscription"
    :product-data="productData"
    :product="product"
    :show-latest-report-section-in-market-assessments="true"
    :show-latest-report-section-in-price-assessments="true"
  >
    <NuxtPage
      :forecast-subscription="forecastSubscription"
      :market-assessment-subscription="marketAssessmentSubscription"
      :prices-assessment-subscription="subscription"
      :product-data="productData"
      :product="product"
      :show-latest-report-section-in-market-assessments="true"
      :show-latest-report-section-in-price-assessments="true"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  CATHODE,
  MARKET,
  SUBSCRIPTION_FORECASTS_CATHODE,
  SUBSCRIPTION_MARKET_ASSESSMENTS_PRECURSOR_ASSESSMENT,
  SUBSCRIPTION_PRICE_ASSESSMENTS_CATHODE,
} from '~/constants/services/constants'
import cathodeData from '~/constants/data-reports/cathode'
import ReportsPage from '~/components/market/ReportsPage.vue'

definePageMeta({ layout: 'services' })

const product = ref(CATHODE)
const productData = ref(cathodeData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_CATHODE)
const marketAssessmentSubscription = ref(
  SUBSCRIPTION_MARKET_ASSESSMENTS_PRECURSOR_ASSESSMENT,
)
const subscription = ref(SUBSCRIPTION_PRICE_ASSESSMENTS_CATHODE)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${CATHODE.name} Data and Reports`,
})
useHead(seo)
</script>
